import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'emotion'
import styled from '@emotion/styled'
import { NavLink } from 'react-router-dom'

const Title = styled.span`
  font-weight: ${props => props.highlighted && 700};
  color: ${props => props.highlighted && '#FFFFFF'};
  margin-right: 8px;
`
const ItemWrapper = styled(NavLink)`
  border-radius: 4px;
  padding: 8px;
  height: 30px;
  color: #90A1B0;
  display: flex;
  align-items: center;
  justify-content: ${props => props.isTitle ? 'flex-start' : 'space-between'};
  margin-top: ${props => props.isTitle ? '16px': '0'};
  
  cursor: pointer;
  transition: all .2s ease;
  
  &:hover{
    background-color: #90A1B0;
    color: #FFFFFF;
  }
`
const activeItem = css`
  background-color: #E50870;
  color: #FFFFFF !important;
`

const MenuItem = ({
  route,
  filterType,
  highlighted,
  title,
  counter,
  onClick
}) => (
  <ItemWrapper
    isTitle={highlighted}
    activeClassName={activeItem}
    to={`${process.env.CHAT_PUBLIC_PATH}/${filterType}/${route}`}
  >
    <Title highlighted={highlighted} >{title}</Title>
    {
      highlighted
        ? counter ? <span>{`   (${counter})`}</span> : null
        : <span>{counter || ''}</span>
    }
  </ItemWrapper>
)

MenuItem.propTypes = {
  highlighted: PropTypes.bool,
  title: PropTypes.string,
  route: PropTypes.string,
  filterType: PropTypes.string,
  counter: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  onClick: PropTypes.func
}

export default MenuItem
